import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import StackedModal from './stacked_modal';

function LeaveDialog({ show, proceed, title, content }) {
  const { t } = useTranslation('bulk_packing');
  return (
    <StackedModal
      isOpen={show}
      title={title || t('bulk_packing:confirm.title')}
      content={content || t('bulk_packing:confirm.content')}
      secondaryAction={{
        content: t('bulk_packing:confirm.btn_1'),
        onAction: () => {
          proceed(true);
        },
      }}
      primaryAction={{
        content: t('bulk_packing:confirm.btn_2'),
        onAction: () => {
          proceed(false);
        },
      }}
      onClose={() => {
        proceed(false);
      }}
    />
  );
}

export default confirmable(LeaveDialog);
